<template>
  <v-app>
    <v-main>
      <core-tile />
    </v-main>
  </v-app>
</template>

<script>
import CoreTile from './components/Core';

export default {
  name: 'cald_ds',

  components: {
    CoreTile,
  },
};
</script>